<ion-row style="margin-bottom: 0px;">
  <ion-col (click)="cancel()" style="padding: 5px;" *ngIf="!oneButton || oneButton==='CANCEL'">
    <ion-button id="footer-btn-cancel" expand="block" size="large" color="danger" size="medium">
      <ion-icon slot="start" [name]="cancelIcon"></ion-icon>
      {{cancelText || 'Annuler'}}
    </ion-button>
  </ion-col>
  <ion-col (click)="ok()" style="padding: 5px;" *ngIf="oneButton!=='CANCEL'">
    <ion-button id="footer-btn-continue" [disabled]="okDisabled"  expand="block" size="medium" color="success">
      {{okText || 'Valider'}}
      <ion-icon slot="end" [name]="okIcon"></ion-icon>
    </ion-button>
  </ion-col>
</ion-row>